import { Maximize2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalIconButton } from '@/shared/ui/Modal';
import { RunLog } from './RunLog';
import { runLogPagePath } from './runLogPath';

/** The run log over the agent tab; the expand icon moves it to its own linkable page. */
export function RunLogPanel({
  open,
  onClose,
  practiceId,
  locationId,
  roleKey,
  agentName,
  focusRunId,
}: {
  open: boolean;
  onClose: () => void;
  practiceId: string;
  locationId: string;
  roleKey: string;
  agentName: string;
  focusRunId?: string;
}) {
  const navigate = useNavigate();
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={`${agentName}'s run log`}
      variant="side"
      size="xl"
      headerActions={
        <ModalIconButton
          label="Expand to full page"
          onClick={() => navigate(runLogPagePath(practiceId, locationId, roleKey, focusRunId))}
        >
          <Maximize2 size={16} aria-hidden />
        </ModalIconButton>
      }
    >
      <RunLog
        practiceId={practiceId}
        locationId={locationId}
        roleKey={roleKey}
        focusRunId={focusRunId}
        agentName={agentName}
      />
    </Modal>
  );
}
